import { UNDERLYING_LIST_MOTIVES } from "src/components-mui/modules/underlying-lists-module/underlying-lists-module.constants";
import { IUnderlyingListItem, IUnderlyingListModuleProps } from "src/components-mui/modules/underlying-lists-module/underlying-lists-module.types";

export const getAllItemsFromUnderlyingListModule = ({
    underlyingLists,
}: Pick<IUnderlyingListModuleProps, "underlyingLists">): IUnderlyingListItem[] =>
    [underlyingLists?.underlyingListForSevenDays, underlyingLists?.underlyingListForThirtyDays].flatMap(lists =>
        lists ? UNDERLYING_LIST_MOTIVES.flatMap(motive => lists[motive].items) : []
    );
